import { useEffect } from 'react';
import { useParams } from 'react-router';

import { useEvent, useEvents } from '@/domains/events';

import { APP_TITLE, buildDocumentTitle } from '../lib/documentTitle';

/**
 * Keeps the browser-tab title in sync with the selected case (route `:eventId`),
 * e.g. "SafeZone – Koningsdag 2026". Falls back to "SafeZone" outside a case.
 */
export function CaseDocumentTitle() {
  const { eventId } = useParams();
  const { data: event } = useEvent(eventId ?? '');
  const { data: allEvents } = useEvents();

  // Use events list as fallback to avoid flicker when switching events (same as Sidebar)
  const selectedFromList = allEvents?.items.find((e) => e.id === eventId);
  const caseName = eventId ? (event?.name ?? selectedFromList?.name) : undefined;

  useEffect(() => {
    document.title = buildDocumentTitle(caseName);
  }, [caseName]);

  useEffect(() => {
    return () => {
      document.title = APP_TITLE;
    };
  }, []);

  return null;
}
